var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-management-panel__statistics"},[_c('statistics-item',{attrs:{"type":"enter","num":_vm.enterNum}}),_c('statistics-item',{attrs:{"type":"leave","num":_vm.leaveNum}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }